import { TEditFirmwareAction, EditFirmwareActionTypes } from './editFirmwareActions';
import { IEditFirmwareState } from './editFirmwareContext';

export const editFirmwareReducer = (state: IEditFirmwareState, action: TEditFirmwareAction): IEditFirmwareState => {
	switch (action.type) {
		case EditFirmwareActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetch,
				fileData: {
					fileId: '',
					fileHash: null,
					fileName: null,
				},
			};
		case EditFirmwareActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditFirmwareActionTypes.SET_ALL_DATA:
			return {
				...state,
				id: action.payload.id,
				typeSelectedFirmware: action.payload.typeSelectedFirmware,
				nameOfFirmware: action.payload.nameOfFirmware,
				versionOfFirmware: action.payload.versionOfFirmware,
				description: action.payload.description,
				fileData: action.payload.fileData,
			};
		case EditFirmwareActionTypes.SET_TYPE_SELECTED_FIRMWARE:
			return {
				...state,
				typeSelectedFirmware: action.payload.typeSelectedFirmware,
			};
		case EditFirmwareActionTypes.CHANGE_NAME_OF_FIRMWARE:
			return {
				...state,
				nameOfFirmware: action.payload.nameOfFirmware,
			};
		case EditFirmwareActionTypes.CHANGE_VERSION_OF_FIRMWARE:
			return {
				...state,
				versionOfFirmware: action.payload.versionOfFirmware,
			};
		case EditFirmwareActionTypes.CHANGE_DESCRIPTION:
			return {
				...state,
				description: action.payload.description,
			};
		case EditFirmwareActionTypes.CHANGE_FILE_DATA:
			return {
				...state,
				fileData: action.payload.fileData,
			};
		case EditFirmwareActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditFirmwareActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditFirmwareActionTypes.RESET_FIELDS:
			return {
				...state,
				id: '',
				typeSelectedFirmware: 1,
				nameOfFirmware: '',
				versionOfFirmware: '',
				description: '',
				fileData: {
					fileId: '',
					fileHash: null,
					fileName: null,
				},
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
